export const BEGIN_TEST_REQUEST = "BEGIN_TEST_REQUEST";
export const BEGIN_TEST_SUCCESS = "BEGIN_TEST_SUCCESS";
export const BEGIN_TEST_FAILURE = "BEGIN_TEST_FAILURE";
export const CLEAR_ALL = "CLEAR_ALL";